Namespace 'Customer.Dashboard'

class Customer.Dashboard.TicketSummaryTextView extends Backbone.View
  template: JST['backbone/templates/customer/dashboard/summary/main/body/ticket_summary_text']
  className: 'summary-text'

  initialize: ({ticketSummary}) ->
    @ticketSummary = ticketSummary
    @doubleBlanksAndNewlinesPattern = /(\s\s+|\n)/g
    @maximumLinesAmount = 5
    @browserTooltipLength = 80


  render: ->
    @$el.html @template
      text: @_text()
      title: @_title()
      email_subject: @_getEmailSubject()
    @$el.addClass('instagram') if @ticketSummary.isInstagram()
    @

  _text: ->
    return 'Unsupported format' if @ticketSummary.isInstagramMessageUnsupported()
    text = @ticketSummary.get('text')?.replace /"/g, '&quot;'
    text = @_cleanSummaryText(text) if !_.isEmpty(text) && @ticketSummary.get('summary_type') == 'email'
    text

  _cleanSummaryText: (text) ->
    html_entities = $.parseHTML(text)
    entities_texts = (entity.textContent for entity in html_entities when entity.nodeName in ["DIV", "#text"])
    entities_texts.join(' ')

  _title: ->
    text = @_text()?.replace(@doubleBlanksAndNewlinesPattern, ' ')
    if text?.length > @maximumLinesAmount * @browserTooltipLength
      return @shortenTitle(text)
    return text

  _getEmailSubject: ->
    @ticketSummary.get('email_summary').subject if @ticketSummary.get('summary_type') == 'email'

  shortenTitle: (text) ->
    ellipsis = '...'
    textParts = []
    for i in [0...@maximumLinesAmount]
      textParts.push text.slice(i * @browserTooltipLength, (i + 1) * @browserTooltipLength)
    return textParts.join('\n').slice(0, -ellipsis.length) + ellipsis
